import { usePlosTranslations } from "../../../../../contexts/PlosTranslationsContext";
import { skeletonCellStyles } from "./playerStatsTable.css";

interface SkeletonRowProps {
  numCols: number;
}

const SkeletonRow = ({ numCols }: SkeletonRowProps) => {
  const { rowLoading } = usePlosTranslations();
  return (
    <tr aria-label={rowLoading}>
      {Array.from({ length: numCols }, (_, i) => (
        <td key={i}>
          <div className={skeletonCellStyles} />
        </td>
      ))}
    </tr>
  );
};

export default SkeletonRow;
